// lista de campos de estabelecimento:
export const listFieldsEstablishment = [
  'establishmentId',
  'establishmentName',
  'nome',
  'tags',
  'descricao',
  'cashbackDefault',
  'dataAlteracao',
  'dataInclusao',
  'disableDate',
  'enableDate',
  'endereco',
  'fotoThumb',
  'idGestor',
  'isPublished',
  // 'partnerEstablishmentId',
  // 'updateDate',
];

// lista de campos de promoção / produto:
export const listFieldsPromotion = [
  'id',
  'tags',
  'description',
  'cashbackDefault',
  'disableDate',
  'enableDate',
  'isPublished',
  'origin',
  'segmentIds',
  'documentType',
  'type',
  'detailsDescription',
  'checkoutCode',
  // 'updateDate',
];

// traduções:
export const fieldTranslations = {
  id: 'ID',
  cashbackDefault: 'Cashback padrão',
  dataAlteracao: 'Data de alteração',
  dataInclusao: 'Data de inclusão',
  descricao: 'Descrição',
  description: 'Descrição',
  establishmentName: 'Nome do estabelecimento',
  disableDate: 'Data de desativação',
  enableDate: 'Data de ativação',
  endereco: 'Endereço',
  fotoThumb: 'Foto (Thumbnail)',
  idGestor: 'ID do gestor',
  isPublished: 'Está publicado',
  nome: 'Nome',
  origin: 'Origem',
  // partnerEstablishmentId: 'ID do estabelecimento parceiro',
  tags: 'Tags',
  // updateDate: 'Data de atualização',
  segmentIds: 'IDs de segmentos',
  documentType: 'Tipo de documento',
  type: 'Tipo',
  detailsDescription: 'Descrição detalhada',
  checkoutCode: 'Código de checkout',
  establishmentId: 'ID do estabelecimento',
};

// condições:
export const actions = [
  '==',
  '!=',
  '<',
  '>',
  'like',
  'array_contains',
  'array_not_contains',
  'includes',
];

// traduções:
export const actionTranslations = {
  '==': 'igual a',
  '!=': 'diferente de',
  '<': 'menor que',
  '>': 'maior que',
  like: 'contém (texto)',
  array_contains: 'contém (array)',
  array_not_contains: 'não contém (array)',
  includes: 'inclui',
};

// tipo de card
export const cardTypes = [
  { label: 'Estabelecimentos', action: 'establishment_list' },
  { label: 'Promoções', action: 'promotion_list' },
  { label: 'Produtos', action: 'product_list' },
];

// outras listas
export const itemIDList = [
  {
    value: 'screen_home',
    label: 'Home',
  },
  {
    value: 'screen_wallet',
    label: 'Carteira',
  },
  {
    value: 'screen_profile',
    label: 'Perfil',
  },
  {
    value: 'screen_notifications',
    label: 'Notificações',
  },
  {
    value: 'screen_chat',
    label: 'Chat',
  },
  {
    value: 'screen_recommended_orgs_list',
    label: 'Comunidades',
  },
];

export const itemActions = [
  {
    value: 'promotion_businessPartner',
    label: 'Promoção de parceiro',
  },
  {
    value: 'promotion_qrCode',
    label: 'Promoção com QR Code',
  },
  {
    value: 'promotion_selfValidation',
    label: 'Promoção com validação pelo usuário',
  },
  {
    value: 'promotion_takeVoucher',
    label: 'Promoção de voucher',
  },
  {
    value: 'product_qrCode',
    label: 'Produto com QR Code',
  },
  {
    value: 'product_selfValidation',
    label: 'Produto com validação pelo usuário',
  },
  {
    value: 'product_takeVoucher',
    label: 'Produto de voucher',
  },
  {
    value: 'establishment_info',
    label: 'Informação de estabelecimento',
  },
  {
    value: 'app_screen',
    label: 'Navegação no App',
  },
];

export const urlActions = [
  {
    value: 'browser',
    label: 'Browser',
  },
  {
    value: 'webview',
    label: 'Webview',
  },
];
